module.exports = __webpack_public_path__ + "static/img/icon_gflogo.ce9d54a8.png";